module.exports = __webpack_public_path__ + "static/media/Portrait-10276.547ed310.jpg";